"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AccountCircle = _interopRequireDefault(require("@tvg/fuse-icons/lib/AccountCircle"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledIconButton = require("./styled-icon-button");
var _excluded = ["dataTestId", "disabled", "text", "notification"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var propTypes = {
  href: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string.isRequired,
  dataTestId: _propTypes["default"].string,
  notification: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].element,
  size: _propTypes["default"].string
};
var defaultProps = {
  dataTestId: null,
  disabled: false,
  icon: /*#__PURE__*/_react["default"].createElement(_AccountCircle["default"], null),
  notification: undefined,
  size: 'Large'
};
function Component(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var dataTestId = props.dataTestId,
    disabled = props.disabled,
    text = props.text,
    notification = props.notification,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledIconButton.StyledIconButton, _extends({
    className: "fuse-icon-button",
    "aria-label": notification ? "".concat(notification, " notification in ").concat(text) : undefined,
    as: disabled ? 'button' : '',
    "data-testid": dataTestId,
    disabled: disabled
  }, other), notification && /*#__PURE__*/_react["default"].createElement("span", {
    className: "fuse-icon-button__notification notification"
  }, notification), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fuse-icon-button__text"
  }, text));
}
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = exports["default"] = Component;